export interface ProgressiveComponentsModuleConfig {
  allowMachineEdit?: boolean;
  progressiveDefinitionMachinesViewComponentName?: string;
  progressiveDefinitionMachinesEditViewComponentName?: string;
}
export const vsConfigName = "machines.progressives.components.config";
